import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({

    leftGridTypographies: {
        width: "300px",
        color: '#333',
    },
    gridContainer: {
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column-reverse',
        },

    },
    signupButton: {
        color: 'white',
        background: '#F3923D',
        borderRadius: '32.83px',
        width: '153.69px',
        height: '48.78px',
        marginTop: 60,
        marginRight: 25,
        fontFamily: 'Noto Sans JP, sans-serif',
    },
    loginButton: {
        color: '#F3923D',
        width: '153.69px',
        height: '48.78px',
        marginTop: 60,
        background: '#FFFFFF',
        border: '1px solid #F3923D',
        // box-sizing: border-box;
        borderRadius: '32.83px',
        fontFamily: 'Noto Sans JP, sans-serif',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
        float: 'right',
        alignItems: 'flex-end'
    },
    buttonsGrid: {
        margin: "20px auto"
    }

}));